'use client';

import { getENV } from '../../utils/env';
import { useConsentGatedInit } from '../hooks/useConsentGatedInit';
import { useMedalliaDefaultButton } from './hooks/use-medallia-default-button';

import './MedalliaScript.scss';

export const MedalliaLoaderV2 = () => {
    const { NEXT_PUBLIC_MEDALLIA_ID_US, NEXT_PUBLIC_MEDALLIA_ID_CA, NEXT_PUBLIC_LOCALE } = getENV();
    const isCA = NEXT_PUBLIC_LOCALE === 'en-CA';
    const scriptId = isCA ? NEXT_PUBLIC_MEDALLIA_ID_CA : NEXT_PUBLIC_MEDALLIA_ID_US;

    useMedalliaDefaultButton();

    useConsentGatedInit({
        src: `https://resources.digital-cloud.medallia.com/wdcus/${scriptId}/onsite/embed.js`,
        consentGroup: 'C0002',
    });

    return null;
};
